import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import LangSelector from '@/components/navbar/lang';
import Styles from './HeaderActions.style';

const HeaderActions = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.wrapper}>
        <LangSelector />
        <CloseIcon onClick={handleClose} className={Styles.closeIcon} />
      </div>
    </div>
  );
};

export default HeaderActions;
